import { useDispatch, useSelector } from "react-redux";
import { SelectOptionsContainer } from "..";
import { useEffect } from "react";
import { getRetrieveBannerOrder } from "../../store/coffeeShop/banner/order/thunks";
import {
  setRetrieveBannerOrder,
  setRetrieveBannerOrderSlug,
} from "../../store/coffeeShop/banner/order/orderSlice";
import { LoadingComponent } from "../../components";
//getRetrieveBannerMain
export const SettingCoffeeShopBannersOrderMainContainer = () => {
  const { photo, slugItem, showLoading } = useSelector(
    (state) => state.retrieveBannerOrder
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRetrieveBannerOrder());
    // eslint-disable-next-line
  }, []);

  const handleOnChange = (e) => {
    const key = e.target.name;
    let value = e.target.value;
    const file = e.target.files[0];
    value = {
      url: URL.createObjectURL(file),
      type: file.type,
      name: file.name,
    };
    dispatch(setRetrieveBannerOrder({ data: { [key]: value } }));
  };

  const handleOnchage = (e) => {
    dispatch(setRetrieveBannerOrderSlug({ slugItem: e.target.value }));
  };

  return (
    <>
      {!showLoading ? (
        <LoadingComponent />
      ) : (
        <div className="productDetailMainContainer">
          <SelectOptionsContainer
            title={"Lo Más Pedido"}
            handleOnchange={handleOnChange}
            name={"photo"}
            isImageEdit={true}
            value={photo?.photo?.url}
          />
          <SelectOptionsContainer
            title={"Slug"}
            name="slugItem"
            handleOnchange={handleOnchage}
            isInput={true}
            value={slugItem}
          />
        </div>
      )}
    </>
  );
};
